import { render, staticRenderFns } from "./FreightUpdate.vue?vue&type=template&id=293c6296&scoped=true&"
import script from "./FreightUpdate.vue?vue&type=script&lang=js&"
export * from "./FreightUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293c6296",
  null
  
)

export default component.exports